module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" "), _c('b', [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("The Smith’s Forge")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" The Crises of Leading Change "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Failures of Nerve and Failures of Heart")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Resilience "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("The Raw Material of a Tempered Leader")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Working "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Leaders Are Formed in Leading")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Heating "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Strength Is Forged in Self-Reflection")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Holding "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Vulnerable Leadership Requires Relational Security")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Hammering "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Stress Makes a Leader")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Hewing "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Resilience Takes Practice")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Tempering "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Resilience Comes Through a Rhythm of Leading and Not Leading")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Epilogue "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("Why Is This So Hard?")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Acknowledgments "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" Notes "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" PRAISE FOR "), _c('i', [_vm._v("TEMPERED RESILIENCE")]), _vm._v(" "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" ABOUT THE AUTHOR "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")]), _vm._v(" More Titles from InterVarsity Press "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("■")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0